var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'app-active' : _vm.showApp},attrs:{"id":"app"}},[_c('router-view',{attrs:{"cognitoUser":_vm.cognitoUser}}),(_vm.showNotifications)?_c('notifications',{attrs:{"notifications":_vm.notifications,"showSpinner":_vm.showNotificationSpinner}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }